"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
var _inputs = require("../utils/inputs");
var _excluded = ["max", "decimals", "className", "id", "name", "label", "right", "left", "placeholder", "onlyError", "maskPrefix", "maskSuffix", "min", "onChangeWithMaskValue", "showLabel", "showPlaceholder"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function NumberInput(props) {
  var max = props.max,
    decimals = props.decimals,
    className = props.className,
    id = props.id,
    name = props.name,
    label = props.label,
    right = props.right,
    left = props.left,
    placeholder = props.placeholder,
    onlyError = props.onlyError,
    maskPrefix = props.maskPrefix,
    maskSuffix = props.maskSuffix,
    min = props.min,
    _props$onChangeWithMa = props.onChangeWithMaskValue,
    onChangeWithMaskValue = _props$onChangeWithMa === void 0 ? null : _props$onChangeWithMa,
    showLabel = props.showLabel,
    showPlaceholder = props.showPlaceholder,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    mask = _useState2[0],
    setMask = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasContent = _useState4[0],
    setHasContent = _useState4[1];
  var _useField = (0, _formik.useField)(name),
    _useField2 = _slicedToArray(_useField, 3),
    field = _useField2[0],
    meta = _useField2[1],
    helpers = _useField2[2];
  var error = meta.error,
    touched = meta.touched,
    initialValue = meta.initialValue;
  var handleChange = (0, _react.useCallback)(function (e) {
    var target = e.target;
    var _formatNumber = (0, _inputs.formatNumberInput)(target.value, decimals, maskPrefix),
      mask = _formatNumber.mask,
      value = _formatNumber.value;
    if (max && value > max) {
      return;
    }
    if (onChangeWithMaskValue) {
      onChangeWithMaskValue({
        value: value,
        name: target.name
      });
    } else {
      helpers.setValue(value);
    }
    setMask(mask);
    setHasContent(target.value && target.value !== '' || field.value === 0);
  }, [onChangeWithMaskValue, helpers]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    var target = e.target;
    var _formatNumber2 = (0, _inputs.formatNumberInput)(target.value, decimals, maskPrefix, maskSuffix),
      mask = _formatNumber2.mask,
      value = _formatNumber2.value;
    if (max && value > max) {
      return;
    }
    helpers.setTouched(true);
    helpers.setValue(value);
    setMask(mask);
    setHasContent(target.value && target.value !== '' || field.value === 0);
  }, [helpers]);
  (0, _react.useEffect)(function () {
    if (field.value !== undefined) {
      handleChange({
        target: _objectSpread(_objectSpread({}, field), {}, {
          value: String(field.value)
        })
      });
    }
  }, [field.value]);
  (0, _react.useEffect)(function () {
    if (initialValue) {
      var _formatNumber3 = (0, _inputs.formatNumberInput)(String(initialValue), decimals, maskPrefix),
        _mask = _formatNumber3.mask;
      setMask(_mask);
    } else {
      setMask('');
      setHasContent(false);
    }
  }, [initialValue, rest.disabled]);
  var hasValue = field.value && field.value !== '' || field.value === 0;
  var hasError = touched && error;
  var withContent = hasContent || hasValue;
  var icn = (0, _classnames["default"])('form-control', withContent && 'form-control--with-content', hasError && 'is-invalid', right && 'input-group-br-no', left && 'input-group-bl-no');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group ".concat(className || '', " ")
  }, label && /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('col-form-label d-flex justify-content-between', hasError && error && 'text-danger'),
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      visibility: "".concat(withContent || hasError || showLabel ? 'visible' : 'hidden')
    }
  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-input-group"
  }, left && /*#__PURE__*/_react["default"].createElement("span", {
    className: "left-content"
  }, left), /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: icn
  }, field, {
    onBlur: handleBlur,
    onChange: handleChange,
    placeholder: showPlaceholder ? placeholder : label || placeholder,
    name: name,
    id: id
  }, rest, {
    value: !mask ? field.value : mask
  }))), hasError && /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])('col-form-error', hasError && error && 'text-danger'),
    htmlFor: name
  }, hasError));
}
NumberInput.propTypes = {
  onlyError: _propTypes["default"].bool,
  decimals: _propTypes["default"].number,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  showLabel: _propTypes["default"].bool,
  showPlaceholder: _propTypes["default"].bool
};
NumberInput.defaultProps = {
  onlyError: false,
  decimals: 1,
  max: 0,
  min: 0,
  showLabel: false,
  showPlaceholder: false
};
var _default = exports["default"] = NumberInput;